module.exports = __webpack_public_path__ + "media/ibc.9a9ad285.mp4";